import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton/IconButton'
import Icon from '@material-ui/core/Icon/Icon'
import Colors from '../../assets/styles/colors'
import classNames from 'classnames'

const styles = ({breakpoints, spacing: {unit}}) => ({
  root: {
    zIndex: 1,
    width: '100%',
    minHeight: unit * 4,
    boxShadow: `0 1px 2px 0 rgba(0,0,0,0.1)`,
    backgroundColor: Colors.White,
    position: 'relative'
  },
  button: {
    position: 'absolute',
    right: 0,
    top: 0
  },
  content: {
    padding: unit,
    paddingBottom: unit * 1,
    paddingRight: unit * 3,
    [breakpoints.up('sm')]: {
      padding: unit * 2,
      paddingRight: unit * 5
    }
  }
})

const PopuHeader = withStyles(styles)(
  ({
    classes,
    className,
    style,
    contentClassName,
    hideCloseButton,
    onClose,
    children
  }) => {
    return (
      <div className={classNames(classes.root, className)} style={style}>
        {children && (
          <div className={classNames(classes.content, contentClassName)}>
            {children}
          </div>
        )}
        {!hideCloseButton && (
          <IconButton className={classes.button} onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        )}
      </div>
    )
  }
)

PopuHeader.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  style: PropTypes.object
}

export default PopuHeader



// WEBPACK FOOTER //
// ./src/shared/components/popup/PopupHeader.js